import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const Wrap = styled.div`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: center;
  color: var(--blue);
  text-transform: uppercase;
  transition: 0.5s;

  .header-white &,
  .header-black & {
    color: var(--light);
  }

  .opened & {
    color: var(--light);
  }
  cursor: pointer;

  ul {
    position: absolute;
    opacity: 0;
    transition: 0.5s;
  }
  &:hover {
    ul {
      opacity: 1;
    }
  }
  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(10)};
    color: var(--light);
    position: absolute;
    bottom: ${calculateMobileResponsiveSize(45)};
    right: ${calculateMobileResponsiveSize(20)};
    ul {
      display: none;
    }
  }
`
